import DashboardIcon from "@mui/icons-material/Dashboard";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import SportsTennisIcon from "@mui/icons-material/SportsTennis";
import ViewListIcon from "@mui/icons-material/ViewList";
import GroupIcon from "@mui/icons-material/Group";
import CategoryIcon from "@mui/icons-material/Category";

export const AdminRoutes = [
  {
    full_name: "Home",
    children: [
      {
        name: "Dashboard",
        path: "/private/admin/dashboard",
        icon: <DashboardIcon />,
      },
      {
        name: "Classificação",
        path: "/private/admin/ranking",
        icon: <EmojiEventsIcon />,
      },
      {
        name: "Rodadas",
        path: "/private/admin/matches",
        icon: <SportsTennisIcon />,
      },
      {
        name: "Rodadas",
        path: "/private/admin/rounds",
        icon: <ViewListIcon />,
        hidden: true,
      },
    ],
  },
  {
    full_name: "Cadastros",
    children: [
      {
        name: "Jogadores",
        path: "/private/admin/players",
        icon: <GroupIcon />,
      },
      {
        name: "Categorias",
        path: "/private/admin/categories",
        icon: <CategoryIcon />,
      },
    ],
  },
];
